import React from 'react';
import {DropdownButton} from "react-bootstrap";
import {getCheckoutPrice, getNumOfItemsInOrderText, formatCredits, formatMoney, formatPoints} from '../../common/basket';
import StoreOrderSummary from '../../containers/store/StoreOrderSummary';
import {translate} from '../../i18n/translate';

class StoreCart extends React.Component {
    isDropDownClosed = (isOpen) => {
        this.props.isDropDownClosed(!isOpen && !this.props.showUpdateRecurringModal);
    };

    render() {
        const showPoints = (this.props.staticData || {}).showItemPoints && (this.props.orderedItems.filteredItems || []).length > 0;
        const itemsNumText = getNumOfItemsInOrderText(this.props.orderedItems, this.props.extraCreditItem);
        const itemsClassName = "cart-items" + ((this.props.remainingCredits.show || showPoints) ? "-credits" : "");
        const remainingBalanceAsCredits = this.props.totals.orderTotal && this.props.totals.orderTotal.remainingBalanceAsCredits;
        const showRemainingBalanceAsCredits = remainingBalanceAsCredits > 0;
        const credits = formatCredits(this.props.remainingCredits.credits);
        const missingPoints = showPoints ? this.props.staticData.minimumPerOrder - this.props.totals.points : 0;
        return (<div>
            <div className="order-summary-header-container">
                <div>
                    <i className="cart-icon"/>
                    <div className={itemsClassName}>{itemsNumText}</div>
                    {missingPoints > 0 &&
                        <div className="cart-credits">Add {formatPoints(missingPoints)} p. to Checkout</div>
                    }
                    {!showPoints && this.props.remainingCredits.show ?
                        showRemainingBalanceAsCredits ?
                            <div className="cart-credits balance-as-credit"><span>{credits + " Credits"}</span><span className="balance-as-credit">{"Balance " + formatMoney(remainingBalanceAsCredits)}</span></div>
                            :
                            <div className="cart-credits">{credits + " " + translate("Remaining") + " " + this.props.creditItemLabel}</div>
                            : undefined
                    }
                    <div className={"cart-price" + (showRemainingBalanceAsCredits ? " balance-as-credit" : "")}>{getCheckoutPrice(this.props.totals)}</div>
                </div>
                {!this.props.readonly ?
                    <div className="cart-button">
                        <DropdownButton title={translate('Cart')} id="cart-dropdown-btn" pullRight={true}
                                        // noCaret={true}
                                        bsStyle="default" onToggle={this.isDropDownClosed}>
                            <StoreOrderSummary items={this.props.items}/>
                        </DropdownButton>
                    </div>
                    : undefined
                }
            </div>
            {this.props.readonly ?
                <StoreOrderSummary items={this.props.items} readonly={true}/>
                : undefined
            }
        </div>);
    }
}

export default StoreCart;


// WEBPACK FOOTER //
// ./src/components/store/StoreCart.js